if (!customElements.get('shop-the-look-product')) {
  class ShopTheLookProduct extends HTMLElement {

    constructor() {
      super();
      this.form = this.querySelector('[data-shop-look-form]');
      this.handle = this.getAttribute('handle');
      this.form.addEventListener('submit', (event) => event.preventDefault());
      this.initProductForm();
    }

    async initProductForm() {
      
      function variantOptionDisplay(event) {
        const { form } = event.target;
        const { target } = event;
        if ('swatchInputGroup' in target.dataset) {
          form.querySelector(`[data-option-header="${target.dataset.swatchInputGroup}"]`).innerText =
            target.dataset.swatchInput;
        }
      }
      
      function onOptionChangeHandler(event, product, hasSizeOption) {
        const { variant } = event.dataset;
        const { target } = event;
        const { form } = target;
        form.querySelector('img').src = variant.featured_image.src.replace('.jpg', '_600x600.jpg');
        if (variant === null) {
          target.form.elements.add.setAttribute('disabled', true);
        } else if (!variant.available) {
          target.form.elements.add.setAttribute('disabled', true);
          variantPriceChange(product, variant, form);
        } else {
          target.form.elements.add.removeAttribute('disabled');
          variantPriceChange(product, variant, form);
        }
        if (product.options.length > 1 && hasSizeOption) {
          toggleAvailableVariants(product, target.form);
        } else if (
          variant &&
          product.options.length === 1 &&
          product.options.some(
            (opt) => opt.name === 'Color' || opt.name === 'Metal' || opt.name === 'Stone' || opt.name === 'Sign' || opt.name === 'Letter'
          )
        ) {
          toggleAvailableVariants(product, target.form);
        } else if (
          product.options.length === 2 &&
          product.options.some(
            (opt) => opt.name === 'Letter'
          )
        ) {
          toggleAvailableVariantsReversed(product, target.form);
        }
      
        variantOptionDisplay(event);
      }

      const productJSON = await fetch(`/products/${this.handle}.js`)
        .then((response) => response.json())
        .then((prodJSON) => prodJSON);
      const hasSizeOption = productJSON.options.some((option) => option.name === 'Size');
      const optionChange = (event) => {
        onOptionChangeHandler(event, productJSON, hasSizeOption);
      };
      const prodForm = new Shopify.theme.productForm.ProductForm(this.form, productJSON, {
        onOptionChange: optionChange,
        onFormSubmit: onFormSubmit,
      });
      if (productJSON.available && hasSizeOption) {
        toggleAvailableVariants(productJSON, prodForm.element);
      } else if (
        productJSON.options.length === 1 &&
        productJSON.options.some(
          (opt) => opt.name === 'Color' || opt.name === 'Metal' || opt.name === 'Stone' || opt.name === 'Sign' || opt.name === 'Letter'
        )
      ) {
        toggleAvailableVariants(productJSON, prodForm.element);
      } else if (
        productJSON.options.length === 2 &&
        productJSON.options.some(
          (opt) => opt.name === 'Letter'
        )
      ) {
        toggleAvailableVariantsReversed(productJSON, prodForm.element);
      }
    }
  }
  customElements.define('shop-the-look-product', ShopTheLookProduct);
}